// extracted by mini-css-extract-plugin
export default {"modal":"FileViewer_modal__bzZaV","pdf-zoom-reset":"FileViewer_pdf-zoom-reset__X3RZk","loader":"FileViewer_loader__F+NXw"};